import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { Project } from "@/models/project.model"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { type IProject } from "@/interfaces/api/project.interface"
import { ProjectRepository } from "@/repositories/project-repository"
import { useProjectStore } from "@/store/projects.store"
import { storeToRefs } from "pinia"

export class ProjectController extends GenericModelController<
  Project,
  IProject,
  ProjectRepository
> {
  constructor() {
    const projectStore = useProjectStore()
    const { projects } = storeToRefs(projectStore)
    const storeFunctionsConfig = {
      collection: projects
    }

    super(Project, storeFunctionsConfig, new ProjectRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(Project, projects)
  }
}
